/**
 * Debounce - group a series of sequential calls to a function
 * into a single call to that function after it stops getting
 * called for `wait` amount of ms.
 * @param {Function} fn
 * @param {Number} wait
 */
const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

/**
 * Throttle - ensure a function is only called at most once
 * 
 * @param {Function} mainFunction 
 * @param {Number} delay 
 * @returns {Function}
 */
const throttle = (mainFunction, delay) => {
  let timerFlag = null;

  return (...args) => {
    if (timerFlag === null) {
      mainFunction(...args);
      timerFlag = setTimeout(() => {
        timerFlag = null;
      }, delay);
    }
  };
}

/**
 * Scroll reveal animations.
 */

/**
 * Handle animation intersection.
 */
const handleAnimationIntersection = (entries, observer) => {
  entries.forEach((entry) => {
    entry.target.classList.toggle('is-animated', entry.isIntersecting);
    if (entry.isIntersecting && entry.target.hasAttribute('data-once')) {
      observer.unobserve(entry.target);
    }
  });
};

/**
 * Observer.
 */

/**
 * Animate elements.
 */
const animateElements = (wrapper = document) => {
  const animatedElements = wrapper.querySelectorAll('[data-animate]');

  /**
   * Attach observer.
   */
  animatedElements.forEach((element) => {
    const options = {
      rootMargin: element.hasAttribute('data-margin') ? element.getAttribute('data-margin'): '100% 0px 0px 0px',
      threshold: 0.2,
    };
    const observer = new IntersectionObserver(handleAnimationIntersection, options)
    
    observer.observe(element);
  });
}

animateElements();

/**
 * Are objects equal
 * 
 * @param {Object} object1
 * @param {Object} object2
 * @returns {Boolean}
 */
const areObjectsEqual = (object1, object2) => {
  return JSON.stringify(object1) === JSON.stringify(object2);
}

/**
 * Scroll locker
 */
let scrollPosition = 0;
const body = document.querySelector('body');

function enabledBodyScrollLock() {
  scrollPosition = window.scrollY;
  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${scrollPosition}px`;
  body.style.width = '100%';
}

function disableBodyScrollLock() {
  body.style.removeProperty('overflow');
  body.style.removeProperty('position');
  body.style.removeProperty('top');
  body.style.removeProperty('width');
  window.scroll({top: scrollPosition, left: 0});
}

const ScrollLocker = {
  lock: enabledBodyScrollLock,
  unlock: disableBodyScrollLock
};

/**
 * Toggle vimeo video.
 * 
 * @param {HTMLIFrameElement} video 
 * @param {String} action 
 */
const toggleVimeoVideo = (video, action = 'play') => {
  video.contentWindow.postMessage(`{"method":"${action}"}`, '*');

  // Play and Pause Youtube Video
  if (action === 'play') {
    video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  } else if (action === 'pause') {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }
}